import { SensitivityAnalysisResult, SensitivityFeatureKey } from '@aloft/toolkit-shared';

import { createContext, useContext } from 'react';

type PropertyGridSensitivityContextValue = {
  sensitivityResult?: SensitivityAnalysisResult;
  sensitivityFeatureKey?: SensitivityFeatureKey;
};

export const PropertyGridSensitivityContext = createContext<PropertyGridSensitivityContextValue>(
  {},
);

export const useSensitivityContext = () => useContext(PropertyGridSensitivityContext);
